import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Test, TestsSummary, TestSummary} from '../../data/models/test/test';
import {Page} from '../../data/models/page';
import {TestFilters} from '../../data/models/filters/test-filters';

@Injectable({
  providedIn: 'root'
})
export class TestService {

  constructor(
    private http: HttpClient,
  ) {
  }


  addTest(data: {
    name: string;
    type: string;
  }): Promise<Test> {

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('type', data.type);

    return this.http.post<Test>(`api/tests`, formData)
      .toPromise();
  }


  getTest(testId: number): Promise<Test> {
    return this.http.get<Test>(`api/tests/${testId}`)
      .toPromise();
  }

  getTestSummary(testId: number): Promise<TestSummary> {
    return this.http.get<TestSummary>(`api/tests/${testId}/summary`)
      .toPromise();
  }


  activateTest(testId: number): Promise<Test> {
    return this.http.post<Test>(`api/tests/${testId}/actions/activate`, new FormData())
      .toPromise();
  }


  deactivateTest(testId: number): Promise<Test> {
    return this.http.post<Test>(`api/tests/${testId}/actions/deactivate`, new FormData())
      .toPromise();
  }


  updateTest(testId: number, newData: {
    name?: string,
    description?: string,
    maxDuration?: string | null,
  }): Promise<Test> {

    const formData = new FormData();
    if (newData.name) {
      formData.append('name', newData.name);
    }
    if (newData.description !== undefined) {
      formData.append('description', newData.description);
    }
    if (newData.maxDuration !== undefined) {
      formData.append('maxDuration', newData.maxDuration == null ? '00:00:00' : newData.maxDuration);
    }

    return this.http.put<Test>(`api/tests/${testId}`, formData)
      .toPromise();
  }


  deleteTest(testId: number): Promise<void> {
    return this.http.delete<void>(`api/tests/${testId}`)
      .toPromise();
  }


  searchTests(
    filters: TestFilters,
    sort: string[], pageSize = 50, pageNumber = 0
  ): Promise<Page<Test>> {

    let httpParams = new HttpParams()
      .set('size', pageSize.toString())
      .set('page', pageNumber.toString());

    if (filters.search && filters.search.length > 0) {
      httpParams = httpParams.set('search', filters.search);
    }

    if (filters.type !== undefined && filters.type !== null) {
      httpParams = httpParams.set('type', filters.type.toString());
    }

    if (filters.isActivated !== undefined && filters.isActivated !== null) {
      httpParams = httpParams.set('isActivated', filters.isActivated.toString());
    }

    if (sort.length > 0) {
      sort = sort.map(function(x){ return x.replace("isActivated","activateDate") });
      httpParams = httpParams.set('sort', sort.join(','));
    }

    return this.http.get<Page<Test>>(`api/tests`, {
      params: httpParams
    }).toPromise();
  }

  getTestsSummary(): Promise<TestsSummary> {
    return this.http.get<TestsSummary>(`api/tests/summary`)
      .toPromise();
  }

  uploadBanner(testId: number, formData: FormData): Promise<any> {
    const url = `/api/tests/${testId}/banner`;
    console.log('Sending request to:', url);
    return this.http.post<any>(url, formData).toPromise()
      .then(response => {
        console.log('Response:', response);
        return response;
      })
      .catch(error => {
        console.error('Error:', error);
        throw error;
      });
  }

}
